"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var BlockedIcon = function BlockedIcon(props) {
  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M16.8449 1.56513L1.55511 16.8549L0.612305 15.9121L15.9021 0.62232L16.8449 1.56513Z",
    fill: "#75767A"
  }, colorStyles)));
};

BlockedIcon.propTypes = _inline_svg2.default.propTypes;
BlockedIcon.defaultProps = _inline_svg2.default.defaultProps;
var _default = BlockedIcon;
exports.default = _default;